module.exports = __webpack_public_path__ + "static/media/0110_LE_SOL_LEGNI_WALNUT.958a9714.png";